// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"390535f5","787":"026d826d"}[chunkId] + ".chunk.js";
};